module.exports = __webpack_public_path__ + "static/3dmodel01-6278dd10808cb6d753107c5cc6633713.jpg";